module.exports = __webpack_public_path__ + "img/subscribe.6f312680.png";